export function queryString(params, options = {}) {
    const encode = options.encode !== false;
    const pairs = [];
    for (const [key, value] of Object.entries(params)) {
        if (Array.isArray(value)) {
            for (const item of value)
                pushPair(pairs, key, item, encode, options);
        }
        else {
            pushPair(pairs, key, value, encode, options);
        }
    }
    return pairs.join('&');
}
function pushPair(pairs, key, value, encode, options) {
    if (value === undefined || (value === null && options.skipNulls))
        return;
    const normalized = value === null ? '' : String(value);
    const encodedKey = encode ? encodeURIComponent(key) : key;
    const encodedValue = encode ? encodeURIComponent(normalized) : normalized;
    pairs.push(`${encodedKey}=${encodedValue}`);
}
